export function mapErrorsToString(error: any) {
    if (typeof error === 'string') {
        return error
    }

    if (typeof error === 'object') {
        if (error && error.message) {
            return error.message
        }
    }

    return ''
}